module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/landing-mobile-produs.4dc6e507.png";